<script setup lang="ts">
import { ContentResults } from "@/types/Facet";
const route = useRoute();
const { $fireBangApiDomain } = useNuxtApp();

// 記事情報取得
const { data: fetchContdata } = await useFetch(`${$fireBangApiDomain}/api/facet/cont/${route.params.id}`, {
  key:'contData',
  transform: (data: ContentResults) => {
    const results = data ? data.results : null;
    return results;
  },
});


const sections = ref<{ id: number; link: string; title: string; branch: { id: number; link: string; title: string; }[]; }[]>([]);

onMounted(() => {
  fetchContdata.value?.articleSections.map((item) => {
    const createElements = (html:string) => {
    const doc = new DOMParser().parseFromString(html, 'text/html')
    const h3Elements = doc.querySelectorAll('h3');
      if (h3Elements.length > 0) {
        // 配列に変換
        const h3TextArray = Array.from(h3Elements).map((h3Element) => h3Element.textContent);
        return h3TextArray;
      } else {
        return [];
      }
    }
    const elements = createElements(item.text);
    const sectionData = {
      id: item.id,
      link: `#chapter${("00" + item.id).slice(-2)}`,
      title: item.title,
      branch: elements?.map((value, index) => {
        const id = index + 1;
        const branchTitle = value || ''; // null の場合は空文字列に変換
        return {
          id,
          link: `#chapter${("00" + item.id).slice(-2)}-${("00" + id).slice(-2)}`,
          title: branchTitle,
        };
      }),
    };
    sections.value.push(sectionData);
  })
});

const isIndexOpen = ref<boolean>(true);
const isOpen = ref(true)
// アコーディオン開閉要素の高さ取得
const beforeEnter = (el: any) => {
  el.style.height = '0'
};
const enter = (el: any) => {
  el.style.height = el.scrollHeight + 'px';
};
const beforeLeave = (el: any) => {
  el.style.height = el.scrollHeight + 'px';
};
const leave = (el: any) => {
  el.style.height = '0';
};
const toggleState = computed(() =>
  isOpen.value ? "【閉じる】" : "【開く】"
);
</script>

<template>
  <div class="index">
    <div class="index-title">
      この記事の目次<span
        id="index-toggle"
        :class="{ active: isIndexOpen }"
        @click="isOpen = !isOpen"
        >{{ toggleState }}</span
      >
    </div>

    <transition
    name="accordion"
    @before-enter="beforeEnter"
    @enter="enter"
    @before-leave="beforeLeave"
    @leave="leave"
  >
    <ul v-if="isOpen" class="index-list">
      <li v-for="item in sections" :key="item.id">
        {{ item.id }}.<a v-smooth-scroll :href="`${item.link}`">{{ item.title }}</a>
        <ul v-if="item.branch?.length" class="index-list-nest">
          <li v-for="subItem in item.branch" :key="subItem.id">
            <a v-smooth-scroll :href="`${subItem.link}`">{{ subItem.title }}</a>
          </li>
        </ul>
      </li>
    </ul>
    </transition>
  </div>
</template>

<style lang="scss" scoped>
.index {
  margin: 2em 4% 0;
  padding: 1em 4%;
  background-color: #f2f2f2;
  .index-title {
    border-bottom: 1px solid #cbcbcb;
    font-weight: bold;
    span {
      margin: 0 0 0.3em 0.7em;
      display: inline-block;
      color: $colorDarkBlue;
      font-size: px(12.9);
      vertical-align: middle;
    }
  }
  .index-list {
    padding: 0.5em 0 0;
    overflow: hidden;
    transition: all 0.5s ease-out;
    > li {
      a {
        color: $colorDarkBlue;
        font-size: px(12.9);
        text-decoration: underline;
      }
      > a {
        margin: 0 0 0 1em;
      }
    }
    > li:not(:last-of-type) {
      margin: 0 0 0.5em 1.7em;
      text-indent: -1.7em;
    }
    .index-list-nest {
      padding: 0.5em 0 0 0;
      li:not(:last-of-type) {
        margin: 0;
      }
      li {
        padding: 0 0 0 1.7em;
        background: url(~/assets/images/list_dot.png) no-repeat 0.4em 0.6em;
        background-size: 7px auto;
        text-indent: 0;
      }
    }
  }
}
@include media(pc) {
  .index {
    margin: 37px 0 0;
    padding: 25px;
    .index-title {
      font-size: px(18.9);
      span {
        margin: 0 0 0.3em 0.7em;
        font-size: px(11.9);
        cursor: pointer;
      }
    }
    .index-list {
      padding: 22px 0 0;
      > li {
        a {
          font-size: px(15);
        }
      }
      > li:not(:last-of-type) {
        margin: 0 0 1.1em 1.7em;
      }
      .index-list-nest {
        li:not(:last-of-type) {
          margin: 0 0 0.5em;
        }
      }
    }
  }
}
</style>
